module.exports = {
      id: "79e3af7df1d29e309a13e7942fafa560equipment-air-conditioning.svg-usage",
      viewBox: "0 0 100 100",
      url: __webpack_public_path__ + "sprite.ba3d6e28.svg#79e3af7df1d29e309a13e7942fafa560equipment-air-conditioning.svg",
      toString: function () {
        return this.url;
      }
    }